import React from 'react';

import { Box, Paper, Typography } from '@mui/material';

import { formatDateShortWithClock } from '~/services/TimeService';

import ChatterFieldChanges from './ChatterFieldChanges';
import { ChatterPost } from './types';

interface Props {
  post: ChatterPost;
  salesforceUrl?: string;
}

// Salesforce groups consecutive field changes; like Salesforce, the group can't be liked or commented on.
export default function ChatterUpdateGroupCard({ post, salesforceUrl }: Props) {
  return (
    <Paper variant="outlined">
      <Box p={2}>
        <Typography variant="subtitle2">This record was updated.</Typography>
        <Typography variant="caption" color="text.secondary">
          {formatDateShortWithClock(post.createdAt)}
        </Typography>
        <ChatterFieldChanges
          changes={post.changes}
          moreUpdateCount={post.moreUpdateCount}
          salesforceUrl={salesforceUrl}
        />
      </Box>
    </Paper>
  );
}
